import { useQuery } from "@tanstack/react-query";
import { TicketInterface } from "../../../models/TicketModule/Ticket";
import { CACHE_KEY_TICKETS } from "../../../utils/constants";
import ticketService from "../../../services/ticketService/ticketService";
import { DataSelectType } from "../../../models/DataSelectType";

const useTickets = (page: number, pageSize: number, filters?: DataSelectType[], startDate?: string, endDate?: string) =>
  useQuery<TicketInterface[], Error>({
    queryKey: [
      CACHE_KEY_TICKETS,
      page > 0 ? page : null,
      pageSize > 0 ? pageSize : null,
      filters ?? null,
      startDate ?? null,
      endDate ?? null,
    ],
    queryFn: () => ticketService.GetByFilter(page, pageSize, null, null, filters, startDate, endDate),
    initialData: [],
  });

export default useTickets;
